import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'app-inicioview',
  standalone: false,
  templateUrl: './inicioview.component.html',
  styleUrl: './inicioview.component.scss',
})
export class InicioviewComponent implements OnInit {
  constructor(public authService: AuthService) {}

  ngOnInit(): void {}
}
